import {convertOra} from '../../Calcolo_percorso/List/TimeFunction'
import sassari from './atp_sassari.svg'
import L, { imageOverlay,Map } from "leaflet";
import  {useEffect}  from "react";
import Percorso from './Percorso'
import { useLeaflet } from "react-leaflet";
import React from 'react'
import ReactDOM from 'react-dom'
/* import RT from './Rt' */
import { connect } from 'react-redux';
import bus from './bus.png'
import DirectionsBus from '@material-ui/icons/DirectionsBus';
import {fetchPath,selectNewIndex, selectNewMarkerStart, selectNewMarkerEnd,changeNomeFermataStart,changeNomeFermataEnd, changeAziendaRealTime, changeLineaRealTime,changeLayerDrawer} from '../../redux'

 




//creazione dell'html dei real time 
function RealTime  (response,props,table)  {
 //const map  = useLeaflet();
 
 
  
 const drawImage = (image) => {

  var iconStart = L.icon({
    iconUrl: image,
    iconSize: [30, 30],
    iconAnchor:   [15  , 35],
    popupAnchor:  [0, -35]
  });
    return iconStart
    }
 



  const showNull = (valore) =>{
    //funzione per gestire un valore vuoto nei real time
      if (valore === ""){
        return ""
      }else{
        return convertOra(valore)
      }
    }

  const Pippo = (evt) =>{
        
        let variabile = {}
     
     variabile = response.data.realtimeStops[evt.target.parentElement.parentElement.id]
     
     //props.changeAziendaRealTime(variabile.idAzienda)
     //props.changeLineaRealTime(variabile.idLinea)
     props.data.data.aziendaRealTime.aziendaRealTime = variabile.idAzienda
     props.data.data.lineaRealTime.lineaRealTime=variabile.idLinea
    
     props.data.data.changePolyReal(true)
     props.data.data.changeLayerDrawer(false)
    }
     
    /* const  RT = ()=>{
        
      
      
      props.changePolyReal(true)
     
    } */
   /*  useEffect(() => {
      setSubTypeList(
        typeAndAttributes
          .find((x: any) => x.typeName.toString() === currentEvent?.type)
          ?.subTypes.map((y: any) => {
            return {
              value: y.subTypeName,
              label: y.subTypeNameIT,
            };
          })
      );
    }, [currentEvent?.type, typeAndAttributes]);
   */
  /* let table = `<script>
  function Pippo(){
    
  }
  </script><table>
        <thead>
    <tr class="tableStyle">
    <td align="center"class="keyStyle">Linea</td>
    <td align="center"class="keyStyle">Schedulato</td>
    <td align="center"class="keyStyle">Real Time</td>
    <td align="center"class="keyStyle">Visualizza Mezzo</td>
    </tr>
    </thead>
    ${`<tbody>
      ${response.data.realtimeStops.map((respons,index) => (
      `<tr index={${index}}>
        <td align="center"><button onclick="Pippo()">${respons.idLinea}</button></td>
        <td align="center"class="schedTimeStyle">${showNull(respons.oraSched )}</td>
        <td align="center" class="realTimeStyle">${showNull(respons.ora)}</td>
        <td align="center" class="realTimeStyle"><img src="${<DirectionsBus/>}"></img></td>
      </tr>`
      ))}
      </tbody>`.replaceAll(',',' ')}
      </table>
      ` */
      let thead = L.DomUtil.create('thead','theadclass',table)
      let tr = L.DomUtil.create('tr','tableStyle',thead)
      let td = L.DomUtil.create('td','keyStyle',tr)
      let td2 = L.DomUtil.create('td','keyStyle',tr)     
      let td3 = L.DomUtil.create('td','keyStyle',tr)     
      let td4 = L.DomUtil.create('td','keyStyle',tr)      
      td.innerText = "Linea"
      td2.innerText = "Schedulato"
      td3.innerText = "Real Time"
      td4.innerText = "Visualizza Mezzo"
      
      let tbody = L.DomUtil.create('tbody','tbodystyle',table)
      response.data.realtimeStops.map((respons,index)=> {
      let trbody = L.DomUtil.create('tr','tbodystyle',tbody)
      trbody.id = index
      trbody.index = index
      let tdtbody = L.DomUtil.create('td','',trbody)
      let tdtbody2 = L.DomUtil.create('td','schedTimeStyle',trbody)     
      let tdtbody3 = L.DomUtil.create('td','realTimeStyle',trbody)     
      let tdtbody4 = L.DomUtil.create('td','',trbody)  
      let image = L.DomUtil.create('img','imagestyle',tdtbody4)  
      image.src = bus
      
      image.onclick = Pippo
        tdtbody.innerText = respons.idLinea
        tdtbody.id = "1"
        tdtbody2.innerText = showNull(respons.oraSched )
        tdtbody3.innerText = showNull(respons.ora)
        /* props.changeLineaRealTime(response.data.realtimeStops.idAzienda)
         props.changeAziendaRealTime(response.data.realtimeStops.idLinea) */

      })

     
      return  table 
     
    
    
}
  
  
const mapStateToProps = state => {
  return {
      pathData: state.path,
      indexData: state.index,
      positionStart: state.positionStart,
      positionEnd: state.positionEnd,
      markerStart: state.markerStart,
      markerEnd: state.markerEnd,
      position:state.position,
      nomeFermataStart: state.nomeFermataStart,
      nomeFermataEnd:state.nomeFermataEnd,
      layerDrawer : state.layerDrawer,
      aziendaRealTime :state.aziendaRealTime,
      lineaRealTime:state.lineaRealTime

  }
}

const mapDispatchToProps = dispatch => {
  return {
      fetchPath: (url,nome) => dispatch(fetchPath(url,nome)),
      selectIndex: (index) => dispatch(selectNewIndex(index)),
      markerStart: (marker) => dispatch(selectNewMarkerStart(marker)),
      markerEnd: (marker) => dispatch(selectNewMarkerEnd(marker)),
      changeNomeFermataStart: (nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
      changeNomeFermataEnd: (nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
      changeAziendaRealTime: (aziendaRealTime) => dispatch(changeAziendaRealTime(aziendaRealTime)),
      changeLineaRealTime: (lineaRealTime) => dispatch(changeLineaRealTime(lineaRealTime)),
      changeLayerDrawer : (layerDrawer) => dispatch(changeLayerDrawer(layerDrawer))
  }
}
  export default RealTime